import { render, staticRenderFns } from "./RsaGestioneCentroDiurnoProgrammatiComponent.vue?vue&type=template&id=271a6ad4"
import script from "./RsaGestioneCentroDiurnoProgrammatiComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneCentroDiurnoProgrammatiComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaGestioneCentroDiurnoProgrammatiComponent.vue?vue&type=style&index=0&id=271a6ad4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports